import { render } from "./PostCarousel.vue?vue&type=template&id=7a87cf7c"
import script from "./PostCarousel.vue?vue&type=script&lang=js"
export * from "./PostCarousel.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__